import { css } from '@/styled-system/css';

export const dropdownHeaderStyles = css.raw({
  'flexGrow': 0,
  'flexShrink': 0,
  'flexBasis': 'auto',

  '& > .c11n_dropdown__heading': {
    borderStartStartRadius: 'obj.soft',
    borderStartEndRadius: 'obj.soft',
  },
});
